import { memo, useRef, useEffect } from "react";
import { useSelector } from "react-redux";
import { makeStyles } from "@mui/styles";
import { VariableSizeList } from "react-window";

import { View } from "../Base";
import LocationItem from "./LocationItem";
import { selectedLocationSelector } from "../../reducers/ownApp/selectors";
import useWindowDimensions from "../../utils/useWindowDimensions";

const useStyles = makeStyles(() => ({
  container: {
    display: "flex",
    flexDirection: "column",
    height: "100%",
  },
  list: {
    overflow: "auto",
    marginRight: "-14px",
  },
}));

const Locations = memo(({ locationList }) => {
  const listRef = useRef();
  const styles = useStyles();
  const { height: windowHeight } = useWindowDimensions();

  const selectedLocation = useSelector(selectedLocationSelector);

  useEffect(() => {
    if (!selectedLocation) return;
    listRef.current.resetAfterIndex(0, true);
    const selectedIndex = locationList.findIndex(
      ({ location }) => location.locationCode === selectedLocation.locationCode
    );
    if (selectedIndex < 0) return;
    listRef.current.scrollToItem(selectedIndex, "start");
  }, [locationList, selectedLocation]);

  useEffect(() => {
    listRef?.current.resetAfterIndex(0, true);
  }, [locationList]);

  const renderRow = ({ index, style }) => {
    const item = locationList[index];
    return (
      <View key={`locationItem-${index}`} style={style}>
        <LocationItem {...item} />
      </View>
    );
  };

  const getItemSize = (index) => {
    const { volume } = locationList[index];
    return volume ? 200 : 155;
  };

  return (
    <div>
      {Array.isArray(locationList) && (
        <VariableSizeList
          className={styles.noScrollbar}
          ref={listRef}
          height={windowHeight - 186}
          itemCount={locationList.length}
          itemSize={getItemSize}
          width={330}
        >
          {renderRow}
        </VariableSizeList>
      )}
    </div>
  );
});

export default Locations;
